var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"tw-bg-white tw-min-h-screen"},[_c('Loader')],1):_c('div',[(_vm.is_default)?_c('div',[_c('customReport')],1):_c('div',[_c('PlugNPlay')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }